import Card from "../card";

const Navigation = ({ children }: { children?: React.ReactNode }) => {
  return <Card className="m-0 p-0 z-10">{children}</Card>;
};

export default Navigation;
